import {z} from 'zod';

export const WorkshopInterestVehicleTypeSchema = z.enum([
  'VEHICLETYPE_PASSENGER_CAR',
  'VEHICLETYPE_VAN',
  'VEHICLETYPE_TRUCK',
  'VEHICLETYPE_MOTORCYCLE',
  'VEHICLETYPE_BUS',
  'VEHICLETYPE_SEMI_TRUCK',
  'VEHICLETYPE_SEMI_TRAILER',
  'VEHICLETYPE_TRAILER',
  'VEHICLETYPE_CARAVAN',
  'VEHICLETYPE_OTHER',
  'VEHICLETYPE_AGRICULTURAL_MACHINE',
  'VEHICLETYPE_CONSTRUCTION_MACHINE',
]);
export type WorkshopInterestVehicleType = z.infer<typeof WorkshopInterestVehicleTypeSchema>;

export const CustomerInquiryVehicleDetailsSchema = z.object({
  vehicleType: WorkshopInterestVehicleTypeSchema,
  licensePlate: z.string().nullable(),
  vin: z.string().max(17).nullable(),
  make: z.string().nullable(),
  modelFamily: z.string().nullable(),
  trim: z.string().nullable(),
  variant: z.string().nullable(),
  firstRegistration: z.string().nullable(),
  realProductionYear: z.string().nullable(),
  realProductionMonth: z.string().nullable(),
  vehicleClassId: z.string().nullable(),
});
export type CustomerInquiryVehicleDetails = z.infer<typeof CustomerInquiryVehicleDetailsSchema>;

export const CustomerInquiryVehicleInformationSchema = z.object({
  currentMileage: z.number().int().min(0).max(9999999).nullable(),
  additionalInformation: z.string().nullable(),
});
export type CustomerInquiryVehicleInformation = z.infer<
  typeof CustomerInquiryVehicleInformationSchema
>;

export const CustomerInquiryCustomerRequestSchema = z.object({
  id: z.string().uuid(),
  request: z.string(),
  description: z.string().nullable(),
});
export type CustomerInquiryCustomerRequest = z.infer<typeof CustomerInquiryCustomerRequestSchema>;

export const CustomerInquiryResponseBodySchema = z.object({
  vehicleDetails: CustomerInquiryVehicleDetailsSchema,
  vehicleInformation: CustomerInquiryVehicleInformationSchema,
  visitRequest: z.unknown(),
  additionalServices: z.unknown(),
  customerRequests: z.array(CustomerInquiryCustomerRequestSchema),
});
export type CustomerInquiryResponseBody = z.infer<typeof CustomerInquiryResponseBodySchema>;

export type GetCustomerInquiryApiArg = {
  interestId: string;
};

export type UpdateVehicleDetailsApiArg = {
  interestId: string;
  updateVehicleDetailsRequestBody: CustomerInquiryVehicleDetails;
};

export type UpdateVehicleInformationApiArg = {
  interestId: string;
  updateVehicleInformationRequestBody: CustomerInquiryVehicleInformation;
};

export const AddCustomerRequestRequestBodySchema = z.object({
  request: z.string(),
  description: z.string().nullable().optional(),
});
export type AddCustomerRequestRequestBody = z.infer<typeof AddCustomerRequestRequestBodySchema>;

export type AddCustomerRequestApiArg = {
  interestId: string;
  addCustomerRequestRequestBody: AddCustomerRequestRequestBody;
};

export const UpdateCustomerRequestRequestBodySchema = z.object({
  request: z.string(),
  description: z.string().nullable(),
});
export type UpdateCustomerRequestRequestBody = z.infer<
  typeof UpdateCustomerRequestRequestBodySchema
>;

export type UpdateCustomerRequestApiArg = {
  interestId: string;
  customerRequestId: string;
  updateCustomerRequestRequestBody: UpdateCustomerRequestRequestBody;
};

export type RemoveCustomerRequestApiArg = {
  interestId: string;
  customerRequestId: string;
};
